(function () {
  const gate = window.__purchaseGate;
  if (!gate) return;

  function showModal(type) {
    const modal = document.getElementById('PurchaseGateModal');
    if (!modal) return;

    document.getElementById('PurchaseGateLogin').hidden = type !== 'login';
    document.getElementById('PurchaseGateMembers').hidden = type !== 'members';
    document.getElementById('PurchaseGateNoDownloads').hidden = type !== 'no-downloads';

    modal.removeAttribute('hidden');
    modal.setAttribute('open', '');
    requestAnimationFrame(() => modal.setAttribute('active', ''));
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    const modal = document.getElementById('PurchaseGateModal');
    if (!modal) return;
    modal.removeAttribute('active');
    modal.removeAttribute('open');
    document.body.style.overflow = '';
    setTimeout(() => modal.setAttribute('hidden', ''), 300);
  }

  function getQuantity(form) {
    const input = form ? form.querySelector('[name="quantity"]') : null;
    return input ? (parseInt(input.value, 10) || 1) : 1;
  }

  function checkDownloadLimit(form) {
    if (gate.remainingDownloads === undefined) return false;
    const qty = getQuantity(form);
    return qty > gate.remainingDownloads;
  }

  // Intercept ATC button click (capture phase runs before custom element handlers)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('form[data-type="add-to-cart-form"] [type="submit"]');
    if (!btn) return;

    const form = btn.closest('form[data-type="add-to-cart-form"]');

    if (!gate.loggedIn) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showModal('login');
    } else if (!gate.hasAccess) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showModal('members');
    } else if (checkDownloadLimit(form)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showModal('no-downloads');
    }
  }, true);

  // Also intercept form submit (keyboard enter, etc.)
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;

    if (!gate.loggedIn) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showModal('login');
    } else if (!gate.hasAccess) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showModal('members');
    } else if (checkDownloadLimit(form)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showModal('no-downloads');
    }
  }, true);

  // Close handlers
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-purchase-gate-close]')) {
      closeModal();
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();
